<template>
  <!-- RQ "Order Details" card (detail page + data sheet page) -->
  <div class="rqCard">
    <div class="flex mobile:flex-col tablet:flex-row justify-between tablet:items-start gap-2 pb-[10px]">
      <div class="flex items-center gap-1">
        <div class="w-[8px] h-[5px] laptop:h-[8px] rounded-full bg-[#A084E8]" />
        <div class="w-[35px] h-[5px] laptop:h-[8px] rounded-full bg-[#A084E8]" />
        <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Order Details</p>
      </div>
      <div class="tablet:text-right">
        <div class="flex items-center mobile:justify-between tablet:justify-end gap-2">
          <span class="text-[14px] tablet:text-[15px] text-[#333333]">Order Status:</span>
          <span
            class="text-[12px] tablet:text-[13px] largeDesktop:text-[14px] font-medium py-[3px] px-[12px] rounded-[5px] text-white"
            :style="{ backgroundColor: rqStatusColor(order.status_text) }">{{ order.status_text || '-' }}</span>
        </div>
        <p v-if="statusDescription" class="m-0 mt-2 text-[12px] leading-[1.2] text-[#999999]">{{ statusDescription }}</p>
      </div>
    </div>
    <!-- QR box just for mobile / tablet (the QR card below is laptop+) -->
    <div v-if="qr?.qrcodeUrl" class="bg-white py-[10px] mobile:flex laptop:hidden justify-between items-center">
      <div>
        <span class="m-0 text-[12px] text-[#F67280]">Technician</span>
        <p class="m-0 text-[14px] font-semibold text-[#333333]">{{ order.technician?.first_name || '-' }}</p>
      </div>
      <img :src="qr.qrcodeUrl"
        class="w-[60px] h-[60px] object-contain rounded-[5px] p-[4px] shadow-[0px_0px_17px_-2px_#ccc]"
        alt="QR code">
    </div>

    <!-- below laptop: label left / value right rows with thin dividers (same as Job Details) -->
    <div class="laptop:hidden flex flex-col text-[14px] text-[#333333]">
      <div class="flex justify-between items-center gap-2 py-[8px] border-t border-[#EFEFEF]">
        <span>Created:</span>
        <span class="text-right">{{ formatDate(order.created_at) }}</span>
      </div>
      <div class="flex justify-between items-center gap-2 py-[8px] border-t border-[#EFEFEF]">
        <span>System Type:</span>
        <span class="px-[10px] py-[2px] rounded-full text-white text-[12px] bg-[#7695FF]">{{ order.type || '-' }}</span>
      </div>
      <div class="flex justify-between items-center gap-2 py-[8px] border-y border-[#EFEFEF]">
        <span>Order ID:</span>
        <span class="px-[10px] py-[2px] rounded-full text-white text-[12px] bg-[#5BC0BE]">{{ order.id }}</span>
      </div>
    </div>
    <div
      class="mobile:hidden laptop:flex flex-row justify-between items-center gap-2 p-2.5 border border-[#EFEFEF] rounded-[5px]">
      <p class="m-0 text-[14px] largeDesktop:text-[16px] text-[#333333]">Created: {{
        formatDate(order.created_at) }}
      </p>
      <div class="flex items-center gap-3 flex-wrap">
        <span class="p-[5px] text-[14px] rounded-full bg-[#EFEFEF]/50 text-[#333333]">System Type:
          <span class="ml-1 px-2 py-[2px] rounded-full text-white text-[13px] bg-[#7695FF]">{{ order.type || '-'
          }}</span>
        </span>
        <span class="p-[5px] text-[14px] rounded-full bg-[#EFEFEF]/50 text-[#333333]">Order ID:
          <span class="ml-1 px-2 py-[2px] rounded-full text-white text-[13px] bg-[#5BC0BE]">{{ order.id
          }}</span>
        </span>
      </div>
    </div>
    <div class="grid grid-cols-1 tablet:grid-cols-2 gap-[15px] mt-[15px]">
      <div class="tablet:col-span-2">
        <span class="rqLabel">Service Address:</span>
        <p class="rqValue">{{ order.address?.address || '-' }}</p>
      </div>
      <div>
        <span class="rqLabel">PerfectMatch Schedule:</span>
        <p class="rqValue">{{ formatDate(order.inspection_datetime) }}</p>
      </div>
      <div>
        <span class="rqLabel">Installation Date:</span>
        <p class="rqValue">{{ formatDate(order.installation_datetime) }}</p>
      </div>
      <div v-if="order.appointment_notes" class="tablet:col-span-2">
        <span class="rqLabel">Appointment Notes:</span>
        <p class="rqValue whitespace-pre-line">{{ order.appointment_notes }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { rqStatusColor, rqStatusDescription } from "../../services/rqApi";

export default {
  props: {
    order: { type: Object, required: true },
    // qr code (status >= 5): small box below laptop
    qr: { type: Object, default: null },
  },
  computed: {
    statusDescription() {
      return rqStatusDescription(this.order?.status, this.order?.consumer?.first_name);
    },
  },
  methods: {
    rqStatusColor,
    // API dates are unix seconds (as strings); local time, same as the RQ History list
    formatDate(ts) {
      if (!ts || Number(ts) <= 0) return "-";
      return moment.unix(Number(ts)).format("MM/DD/YYYY hh:mm A");
    },
  },
};
</script>
